export const environment = {
  production: false,
  services: {
    rhemaServer: 'https://rhemaapi.olivetech.com/api'
    //rhemaServer: 'http://localhost:3000/api'
    //rhemaServer: 'https://api.rhema.app/api'
    }, 
  fileURL: 'https://s3.us-east-2.amazonaws.com/rhema-bucket-dev/rhema-files/',
  supportURL: 'https://s3.us-east-2.amazonaws.com/rhema-bucket-dev/rhema-support-files/',
};